const ufeApi = require('services/api/ufeApi');

// https://confluence.sephora.com/wiki/display/ILLUMINATE/WIP+-+GET+Same+Day+User+Specific+Product+Details+API

function getSameDaySpecificProductDetails(profileId = 'current', productId, skuId = null) {
    let url = `/api/users/profiles/${profileId}/samedayproduct/${productId}`;
    const queryParams = [];

    if (skuId !== null) {
        queryParams.push(`?preferedSku=${skuId}`);
    }

    url = url + queryParams.join('&');
    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => data.errorCode ? Promise.reject(data) : data);
}

module.exports = getSameDaySpecificProductDetails;
